// src/auth/ResetPassword.jsx
import { useState } from "react";
import {
  pageStyle, cardStyle, logoStyle, headingStyle,
  labelStyle, inputStyle, errorStyle, btnPrimaryStyle, linkBtnStyle, googleFont,
} from "./authStyles";

export default function ResetPassword({ resetToken, onSuccess, onCancel }) {
  const [password, setPassword] = useState("");
  const [confirm,  setConfirm]  = useState("");
  const [error,    setError]    = useState("");
  const [busy,     setBusy]     = useState(false);

  const handleReset = async (e) => {
    e.preventDefault();
    setError("");
    if (password !== confirm) { setError("Passwords do not match."); return; }
    if (password.length < 8)  { setError("Password must be at least 8 characters."); return; }

    setBusy(true);
    try {
      const res  = await fetch("/.netlify/functions/wc-auth-reset", {
        method:  "POST",
        headers: { "Content-Type": "application/json" },
        body:    JSON.stringify({ reset_token: resetToken, new_password: password }),
      });
      const data = await res.json();
      if (!res.ok) { setError(data.error || "Reset failed. The link may have expired."); setBusy(false); return; }
      onSuccess(data);
    } catch {
      setError("Network error. Please try again.");
    }
    setBusy(false);
  };

  return (
    <div style={pageStyle}>
      {googleFont}
      <div style={cardStyle}>
        <div style={{ textAlign: "center", marginBottom: 28 }}>
          <div style={logoStyle}>✍️</div>
          <h1 style={{ ...headingStyle, fontSize: 22 }}>Set New Password</h1>
          <p style={{ color: "#8b949e", fontSize: 13, margin: 0 }}>Choose a new password for your account.</p>
        </div>

        <form onSubmit={handleReset} style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          <div>
            <label style={labelStyle}>New Password</label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)}
              placeholder="Min. 8 characters" required style={inputStyle} />
          </div>
          <div>
            <label style={labelStyle}>Confirm Password</label>
            <input type="password" value={confirm} onChange={e => setConfirm(e.target.value)}
              placeholder="Re-enter password" required style={inputStyle} />
          </div>
          {error && <div style={errorStyle}>⚠ {error}</div>}
          <button type="submit" disabled={busy} style={btnPrimaryStyle(busy)}>
            {busy ? "Saving…" : "Save New Password →"}
          </button>
          <div style={{ textAlign: "center" }}>
            <button type="button" onClick={onCancel} style={{ ...linkBtnStyle, color: "#388bfd", fontWeight: 700 }}>
              ← Back to Sign In
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
